export default __webpack_public_path__ + "static/media/16418216950.3b90ba40.JPG";